export default {
  tab: {
    index: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
  },

  prospectItem: {
    usMarket: 'US Market',
    euroMarket: 'Europe Market',
    asianMarket: 'Asian Market',
    oilWtiPrice: 'OIL WTI Price',
    commodity: 'COMMODITY',
    brentOilPrice: 'BRENT OIL Price',
    centralBankRate: 'Central Bank Rate',
    worldGoldPrice: 'World Gold Price',
    vnIndex: 'VN-INDEX',
    vnMarket: 'Vietnamese Market',
    hnxIndex: 'HNX-INDEX',
    vn30: 'VN-30',
    hnx30: 'HNX-30',
    foreignFlow: 'Foreign Flow',

    Up: 'UP',
    Down: 'DOWN',

    Price: 'Price',
    PriceChange: 'Price Change',
    PercentPriceChange: 'Percent Price Change',

    ExchangeRate: 'Exchange Rate',
    PreviousExchangeRate: 'Previous Exchange Rate',

    IndexValue: 'Index Value',
    IndexChange: 'Index Change',
    PercentIndexChange: 'Percent Index Change',

    ForeignBuyValueMatched: 'Foreign Buy Value',
    ForeignSellValueMatched: 'Foreign Sell Value',
    NetForeign: 'Foreign Net',
  },
};
